import React from 'react'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import ContactRequests from './ContactRequests'
import ContactRequestsStore from '../../stores/contact-requests'

@withRouter
@observer
class _ContactRequests extends React.Component {
  constructor (props) {
    super(props)
    this.store = new ContactRequestsStore()
  }

  onChangeSort = orderByNew => (e) => {
    const { listProps } = this.store
    const { order, orderBy } = listProps
    let orderNew = ''
    if (orderBy === orderByNew) {
      if (order === 'desc') {
        orderNew = 'asc'
      } else {
        orderNew = 'desc'
      }
    } else {
      orderNew = 'desc'
    }

    this.store.onChangeSort(orderNew, orderByNew)
  }

  onChangePage = (e, page) => this.store.onChangePage(page)

  onChangeRowsPerPage = ({ target: { value } }) => this.store.onChangeRowsPerPage(value)

  onChangeFilters = name => (object) => {
    let value = null
    if (object.hasOwnProperty('target')) {
      value = object.target.value
    } else {
      value = object
    }
    this.store.onChangeFilter(name, value)
  }

  onClickRow = (e, id) => {
    if (e.ctrlKey || e.metaKey) {
      window.open(`/contact-requests/${id}`, '_blank')
    } else {
      this.props.history.push(`/contact-requests/${id}`)
    }
  }

  onUploadCSV = (data) => {
    return this.store.uploadData(data)
  }

  render () {
    const {
      listProps,
      requests
    } = this.store

    return (
      <ContactRequests
        {...this.props}
        {...listProps}
        items={requests}
        onChangeSort={this.onChangeSort}
        onChangeFilters={this.onChangeFilters}
        onChangePage={this.onChangePage}
        onChangeRowsPerPage={this.onChangeRowsPerPage}
        onClickRow={this.onClickRow}
        onUploadCSV={this.onUploadCSV}
      />
    )
  }
}

export default _ContactRequests
